import React, { useContext, useEffect, useState } from "react";

import "../../../collection/styles/collectionScreen.css";

import Home from "pages/Home";
import Card from "components/ui/Card";

import { CircularProgress, Grid, Typography } from "@mui/material";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import SortContext from "context/SortContext";
import config from "configs/config";
import axios from "axios";
import { encodeStr, formatString } from "utils/encodeDecodeStr";
import { GlobalContext, useGlobalContext } from "context/GlobalContext";
import LoadingSmallCard from "components/ui/Skeleton/LoadingSmallCard";
import { transformData, transformDataForTrayModal } from "utils/transformdata";
import { findSpecificMenu, findSpecificPage, findSpecificSubMenu, hasAccessPage, isAllowed } from "utils/checkUserRigths";
import { usePermissions } from "context/PermissionsContext";
import { useGetCollectionCategory, useGetDuplicateStocks } from "features/collection/hooks/useGetCollectionCategory";
import { ReactComponent as Background } from "assets/icons/bg.svg";
import InfoModal from "components/ui/InfoModal/InfoModal";
import apiClient from "lib/api-client";
import StockSetProduct from "features/Stock/StockSetProduct/components/StockSetProduct";
import ProductSkeleton from "components/ui/Skeleton/ProductSkeleton";
import InfiniteScroll from "react-infinite-scroll-component";
import { useFilter } from "context/FilterContext";
import { useQuery } from "@tanstack/react-query";
import StockDesign from "features/Stock/category/components/StockDesign";
import Product from "../CollectionProductScreen/Product";
import DataNotFound from "components/ui/datanotfound/DataNotFound";

function SubCollectionNew() {
  const { collectionName } = useParams();
  // console.log("collectionName ===>", collectionName);
  const navigate = useNavigate();
  const location = useLocation();
  // const query = new URLSearchParams(location.search);
  // const rangeStock = query.get("rangeStock");
  const rangeStock = location?.state?.rangeStock;

  let preState = location.state;
  //   const catalogUpdate = location?.state?.cataloguUpdate;
  let [subcollectionData, setSubCollectionData] = useState([]);
  const [cardData, setCardData] = useState([]);
  const { setSortOptions, setSelectedSortValue, search, selectedSortValue, setSearch, sortOptions } = React.useContext(SortContext);
  const {
    setAddDesignBtn,
    addDesignBtn,
    setIsInfoBtn,
    infoModalOpen,
    setInfoModalOpen,
    setFilterChangeCount,
    setDisplayCount,
    setSearchResultCount,
    filterChangeCount,
    setDynamicFilterCount,
    dynamicfilterCount,
    setSearchPlaceHolder,
    appliedStartDate,
    appliedEndDate,
    setFilterChangeDesignCount,
    setAppliedStartDate,
    setAppliedEndDate,
  } = useGlobalContext();
  const [loading, setLoading] = useState(true);
  const { setIsCollectionFilter, setFilterValues, setBackendFilterValues, filterValues, setFilterCount } = useFilter();

  // const [collectioCreateOrUpdate, setCollectioCreateOrUpdate] = useState(location?.state?.collection || window?.history?.state?.collection);
  // console.log("window.history.state?.collection ===>", window.history.state?.collection);
  const [collectionCreateOrUpdate, setCollectionCreateOrUpdate] = useState(location.state?.collection ?? window.history.state?.collection);
  const permission = usePermissions();

  const hasAccessEditCollection = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Collection Access"), "edit");

  useEffect(() => {
    setSortOptions([
      { id: 1, name: "Alphabetical Quote (A to Z) " },
      { id: 2, name: "Alphabetical Quote (Z to A)" },
      { id: 3, name: "Design Quantity (High to Low)" },
      { id: 4, name: "Design Quantity (Low to High)" },
    ]);

    if (hasAccessEditCollection) {
      setAddDesignBtn(collectionCreateOrUpdate && !location?.state?.aiIcon);
    } else {
      setAddDesignBtn(false);
    }

    return () => {
      setSortOptions([]);
      setSelectedSortValue(null);
      setAddDesignBtn(false);
      setFilterValues({});
      setFilterCount(0);
      setBackendFilterValues({});
      setIsCollectionFilter(false);
      sessionStorage.removeItem("collectionsProductsData");
      setSearch("");
      setSearchPlaceHolder("Search");
      sessionStorage.removeItem("appliedSortValue");
    };
  }, [collectionCreateOrUpdate]);

  useEffect(() => {
    sessionStorage.setItem("appliedSortValue", selectedSortValue);
  }, [selectedSortValue, sortOptions]);

  useEffect(() => {
    const decodedCollectionName = decodeURIComponent(collectionName);

    if (collectionCreateOrUpdate === undefined) {
      //added for Add Design btn Visibility on redirect
      setCollectionCreateOrUpdate(true);
    }
    if (!location.state?.name) {
      navigate(location.pathname, { state: { name: [decodedCollectionName] }, replace: true });
    }
  }, []);

  //------------------ API Call Start ---------------------\\

  const payload = {
    collection: preState?.name?.[0] || (window?.history?.state && window.history.state.name ? window.history.state.name[0] : ""),
    pageNumber: 1,
    limit: 100,
    searchTerm: search,
    sortBy: selectedSortValue == "1" || selectedSortValue == "2" ? "alphabetical" : selectedSortValue == "3" || selectedSortValue == "4" ? "quantity" : "",
    order: selectedSortValue == "1" || selectedSortValue == "4" ? "asc" : "desc",
  };

  const aiPayload = {
    collectionName: preState?.name?.[0] || (window?.history?.state && window.history.state.name ? window.history.state.name[0] : ""), //60 New design sold in past 60 days
    days: location?.state?.days || 0,
    newDesign: location?.state?.isNewAiDesign || "",
    cadDesign: location?.state?.isCadDesign || "",
    stockDesign: location?.state?.isStockDesign || "",
    searchTerm: search,
    sortBy: selectedSortValue == "1" || selectedSortValue == "2" ? "alphabetical" : selectedSortValue == "3" || selectedSortValue == "4" ? "quantity" : "",
    order: selectedSortValue == "1" || selectedSortValue == "4" ? "asc" : "desc",
    rangeStock: rangeStock ? rangeStock : null,
    selectDesign: location?.state?.isSelectDesign || "",
    ...(location?.state?.isSelectDesign && collectionName === "Binny's Select Designs" || location?.state?.newDesigns && collectionName === "New Designs"
      ? {
          startDate: appliedStartDate || "",
          endDate: appliedEndDate || "",
        }
      : {}),
    isOutOfStock: location?.state?.isOutOfStock || "",
    rangeOutOfStock: location?.state?.rangeOutOfStock || "",
    UnderRatio: location?.state?.UnderRatio || "",
    OverRatio: location?.state?.OverRatio || "",
    newDesigns: location?.state?.newDesigns || "",
  };

  const selectedOption = sortOptions.find((option) => option.id == selectedSortValue);
  const selectedSortBY = selectedOption?.sortBy;
  const selectedSortOrder = selectedOption?.order;
  const isCollectionPage = (collectionName !== "Duplicate Stocks" || collectionName !== "Restricted Stock" || !collectionName.endsWith("Stock")) && !location?.state?.aiIcon;
  const isAiPage =
    (collectionName !== "Duplicate Stocks" || collectionName !== "Restricted Stock" || !collectionName.endsWith("Stock")) && (location?.state?.aiIcon || window.history.state?.aiIcon || false);
  const Class = filterValues?.Class;

  const { subCollectionsQuery, aiSubCollectionsQuery } = useGetCollectionCategory(payload, aiPayload, isCollectionPage, isAiPage);

  const { data: subcollections, isLoading, error, isError } = subCollectionsQuery;
  const { data: aiCollections, isLoading: isAiLoading, error: aiError, isError: isAiError } = aiSubCollectionsQuery;

  //--------------- When API Call Success ----------------\\
  useEffect(() => {
    if (aiCollections?.categories && aiCollections?.categories.length > 0) {
      setSubCollectionData(aiCollections?.categories);
      setLoading(false);
    } else if (subcollections?.data?.length > 0) {
      setSubCollectionData(subcollections?.data);
      setLoading(false);
      //------------ saving data in session storage for store it as  "updateProductsData" when user do  "Add Design" " -----------\\
      const desingsIds = subcollections?.collection?.designs?.map((desing) => transformData(desing));
      sessionStorage.setItem("collectionsProductsData", JSON.stringify(desingsIds));
      sessionStorage.setItem("collectionIdOfProducts", JSON.stringify(subcollections?.collection?._id)); // Neccessary when user Update Collection , Using this key in cart page for api call
    } else {
      setSubCollectionData([]);
      setLoading(false);
    }
  }, [subcollections, aiCollections, addDesignBtn, navigate]);

  //--------------- When user click on card ----------------\\
  const handleClick = (ele) => {
    const encodedCollectionName = encodeURIComponent(collectionName);
    const encodedCollectionCategoryName = encodeURIComponent(`${ele.category}-${ele.count}`);

    const state = {
      ...preState,
      aiIcon: preState?.aiIcon || window.history.state?.aiIcon || false,
      name: [`${preState?.name[0] || window.history.state.name[0]}`, `${ele.category}`],
      subCollectionSearch: search !== "" ? search : "",

      isStockDesign: encodedCollectionName.endsWith("Stocks") || (encodedCollectionName.endsWith("Stock") && !encodedCollectionName.includes("Out")) ? true : false,
      isSelectDesign: collectionName === "Binny's Select Designs" ? true : false,
    };

    navigate(`/Collection/${encodedCollectionName}/${encodedCollectionCategoryName}`, { state });
    // }
  };

  useEffect(() => {
    setSearch(location?.state?.subCollectionSearch || "");
  }, [location]);

  //-----------------When User copy paste URL --------------------\\
  useEffect(() => {
    setFilterCount(0);
    sessionStorage.setItem("filterChangeCount", 0);
    setIsInfoBtn(true);
    const decodedName = decodeURIComponent(collectionName);

    const aiPages = ["Top 30 Sold - 30 Days", "Top 60 Sold - 60 Days", "Top 90 Sold - 90 Days", "New 30 Sold - 30 Days", "New 60 Sold - 60 Days", "New 90 Sold - 90 Days", "Only Cad Designs"];

    let isAiPage = aiPages.includes(decodedName);

    if (!location.state?.name) {
      if (isAiPage) {
        let isCadDesign = decodedName === "Only Cad Designs";

        let days = isCadDesign ? "" : Number(decodedName.split("-")[1]?.split(" ")[1]) || "";

        let isNewAiDesign = isCadDesign ? "" : !decodedName.startsWith("Top");

        navigate(location.pathname, {
          state: { name: [decodedName], days, isNewAiDesign, isCadDesign, aiIcon: true },
          replace: true,
        });
      }
    } else {
      if (!location.state?.name) {
        navigate(location.pathname, { state: { name: [decodedName] }, replace: true });
      }
    }

    return () => {
      setIsInfoBtn(false);
    };
  }, []);

  useEffect(() => {
    setSearchPlaceHolder(
      `Search By ${location?.state?.name[0] === "Duplicate Stocks" || location?.state?.name[0] === "Restricted Stock" || location?.state?.name[0]?.endsWith("Stock") ? "" : "Collection or "}Design Number`
    );
    if (location?.state?.aiIcon) {
      setIsInfoBtn(false);
    }

    if (search === "") {
      setDynamicFilterCount(true);
    }
    const getLength = () => {
      if (collectionName === "Binny's Select Designs") {
        return aiCollections?.categories?.length || 0;
      } else {
        return (aiCollections?.categories?.length || 1) - 1;
      }
    };

    if (dynamicfilterCount) {
      if (collectionName === "Binny's Select Designs") {
        setFilterChangeDesignCount(aiCollections?.designCount);
      }
      setFilterChangeCount(subcollections?.data?.length - 1 || getLength());
      setSearchResultCount(subcollections?.data?.length - 1 || getLength());
    } else {
      if (collectionName === "Binny's Select Designs") {
        setFilterChangeDesignCount(aiCollections?.designCount);
      }
      setSearchResultCount(subcollections?.data?.length - 1 || aiCollections?.cardData?.length || getLength());
      setFilterChangeCount(filterChangeCount);
    }
    setDisplayCount(true);
    return () => {
      setSearchResultCount(0);
      setFilterChangeCount(0);
      setFilterChangeDesignCount(0);
      setDisplayCount(false);
      setSearchPlaceHolder("");
      sessionStorage.setItem("filterChangeCount", 0);
    };
  }, [subcollections, aiCollections]);

  //---------------- When api Response Done ----------------------\\
  if (isLoading || isAiLoading) return <LoadingSmallCard count={24} />;

  if (isError || aiError) return <div style={{ color: "#fff" }}>Error: {error.message}</div>;

  const fetchData = () => apiClient.get(`/api/v1/collection/getCollectionInfo/${subcollections?.collection?._id}`);

  const hasNoResults =
    search &&
    !subcollections?.data?.length &&
    !aiCollections?.categories?.length;

  if (hasNoResults) return <DataNotFound message={`No results found for "${search}"`} />;

  //----------------- Rendering part -------------------------------\\
  return (
    <>
      {(!loading && subcollectionData && subcollectionData?.length > 0) ||
      collectionName === "Duplicate Stocks" ||
      collectionName === "Restricted Stock" ||
      collectionName?.endsWith("Stock") ||
      (aiCollections?.cardData && aiCollections?.cardData?.length > 0) ? (
        <Grid
          container
          className="Grid-padding"
          direction="row"
          justifyContent="flex-start"
          sx={{ flex: "1 1 1", display: "flex", alignItems: "center", justifyContent: "flex-start", gap: "30px", rowGap: "32px" }}
        >
          {subcollectionData &&
            subcollectionData.map((ele, i) => (
              <Grid item key={i} onClick={() => handleClick(ele)}>
                <Card
                  style={{
                    minWidth: 275,
                    maxWidth: "317px",
                    height: 62,
                    borderRadius: "5px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "0 10px",
                  }}
                >
                  <Typography mr={"auto"} fontSize="20px" fontWeight={400} fontFamily="Karla">
                    {ele.category}
                  </Typography>
                  <Typography ml={"auto"} fontSize="20px" fontWeight={400} fontFamily="Karla">
                    {ele.count}
                  </Typography>
                </Card>
              </Grid>
            ))}

          {aiCollections?.cardData?.length > 0 &&
            aiCollections?.cardData?.map((product, ind) => {
              return location?.state?.isStockDesign ? (
                <StockSetProduct product={product} key={product._id} allData={cardData} />
              ) : (
                <Product product={transformDataForTrayModal(product)} index={ind} key={product._id} allData={cardData} />
              );
            })}
        </Grid>
      ) : (
        <div style={{ disply: "flex", textAlign: "center", padding: "40px", justifyContent: "center", alignItems: "center" }}>
          <Background />
        </div>
      )}

      <InfoModal open={infoModalOpen} setOpen={setInfoModalOpen} fetchData={fetchData} title="Collection Details" />
    </>
  );
}

export default SubCollectionNew;
